import { render, staticRenderFns } from "./ImportExcelButton.vue?vue&type=template&id=4b28790e&scoped=true"
import script from "./ImportExcelButton.vue?vue&type=script&lang=js"
export * from "./ImportExcelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28790e",
  null
  
)

export default component.exports